import { useState } from 'react'
import { TypeBox } from '../TypeBox/TypeBox'
import { ScoopButton, ScoopText, ScoopDialog, ScoopColumn } from '../../../../ui'
import styles from './BlendingMethodDialog.module.scss'

const BlendingMethodDialog = ({ onClose, setStep }) => {
    const [active, setActive] = useState('Blended')

    return (
        <ScoopDialog
            open
            onClose={() => {
                onClose()
                setStep(0)
            }}
            maxWidth="md"
            actions={
                <>
                    <ScoopButton variant="grey" onClick={() => setStep(1)}>
                        Back
                    </ScoopButton>
                    <ScoopButton
                        disabled={active.length === 0}
                        onClick={() => setStep(active === 'Blended' ? 3 : 4)}
                    >
                        Continue
                    </ScoopButton>
                </>
            }
        >
            <ScoopColumn className={styles.container}>
                <ScoopText className={styles.title}>Select method</ScoopText>
                <ScoopText className={styles.description}>
                    Select the method of data aggregation you'd like to use. For more information,{' '}
                    <a href="#" className={styles.link}>
                        watch the video.
                    </a>
                </ScoopText>
                <ScoopColumn className={styles.optionsContainer}>
                    <TypeBox
                        title={'Blended'}
                        description={
                            'Select and filter columns from multiple existing datasets ' +
                            'and blend together to create a new blended dataset.'
                        }
                        active={active}
                        setActive={setActive}
                        enabled={true}
                    />
                    <TypeBox
                        title={'Aggregated'}
                        description={
                            'Select and filter columns from a single existing dataset to use in a new aggregated dataset.'
                        }
                        active={active}
                        setActive={setActive}
                        enabled={true}
                    />
                </ScoopColumn>
            </ScoopColumn>
        </ScoopDialog>
    )
}

export default BlendingMethodDialog
